export function sessionTimeCounter(date_start: number, date_end: number) {
    // Find the distance between now and the count down date
    const distance = date_end - date_start;

    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    const hString = hours < 10 ? `0${hours}` : hours.toString();
    const mString = minutes < 10 ? `0${minutes}` : minutes.toString();
    const sString = seconds < 10 ? `0${seconds}` : seconds.toString();

    return `${hString}:${mString}:${sString}`;
};

export function hhmmssToSeconds(str: string) {
    var arr = str.split(':').map(Number);
    return (arr[0] * 3600) + (arr[1] * 60) + arr[2];
};

export function secondsToHHMMSS(seconds: number) {
    const _sec = seconds;
    const _hours = parseInt((_sec / 3600).toString(), 10);
    const _minutes = parseInt(((_sec / 60) % 60).toString(), 10);
    const _seconds = parseInt((_sec % 3600 % 60).toString(), 10);

    return [_hours, _minutes, _seconds].map(function (i) { return i.toString().length === 2 ? i : '0' + i; }).join(':');
};

export function sumTwoTimes(timeOne: string, timeTwo: string) {
    const t1 = hhmmssToSeconds(timeOne);
    const t2 = hhmmssToSeconds(timeTwo);

    return secondsToHHMMSS(t1 + t2);
}

export function errorGenerator(error: unknown) {
    let errorMessage = '';

    if (error instanceof Error) {
        errorMessage = error.message;
    }

    return errorMessage;
}
